import _classCallCheck from "/home/runner/work/graphiql-console/graphiql-console/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/graphiql-console/graphiql-console/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
export var Range = /*#__PURE__*/function () {
  function Range(start, end) {
    var _this = this;

    _classCallCheck(this, Range);

    this.containsPosition = function (position) {
      if (_this.start.line === position.line) {
        return _this.start.character <= position.character;
      } else if (_this.end.line === position.line) {
        return _this.end.character >= position.character;
      } else {
        return _this.start.line <= position.line && _this.end.line >= position.line;
      }
    };

    this.start = start;
    this.end = end;
  }

  _createClass(Range, [{
    key: "setStart",
    value: function setStart(line, character) {
      this.start = new Position(line, character);
    }
  }, {
    key: "setEnd",
    value: function setEnd(line, character) {
      this.end = new Position(line, character);
    }
  }]);

  return Range;
}();
export var Position = /*#__PURE__*/function () {
  function Position(line, character) {
    var _this2 = this;

    _classCallCheck(this, Position);

    this.lessThanOrEqualTo = function (position) {
      return _this2.line < position.line || _this2.line === position.line && _this2.character <= position.character;
    };

    this.line = line;
    this.character = character;
  }

  _createClass(Position, [{
    key: "setLine",
    value: function setLine(line) {
      this.line = line;
    }
  }, {
    key: "setCharacter",
    value: function setCharacter(character) {
      this.character = character;
    }
  }]);

  return Position;
}();
export function offsetToPosition(text, loc) {
  var EOL = '\n';
  var buf = text.slice(0, loc);
  var lines = buf.split(EOL).length - 1;
  var lastLineIndex = buf.lastIndexOf(EOL);
  return new Position(lines, loc - lastLineIndex - 1);
}
export function locToRange(text, loc) {
  var start = offsetToPosition(text, loc.start);
  var end = offsetToPosition(text, loc.end);
  return new Range(start, end);
}